<template>
  <div class="wrap">
    <div class="innerBox">
      <div class="filtrate">
        <el-input
          placeholder="功能集名称"
          class="w350 seekIpt"
          v-model="queryLimit.keyword"
          @keyup.enter.native="searchTab"
        >
          <i slot="suffix" class="el-input__icon el-icon-search" @click="searchTab"></i>
        </el-input>
      </div>
      <div>
        <el-button class="mt20" @click="add" icon="el-icon-circle-plus-outline" type="primary">添加</el-button>
      </div>
      <el-divider></el-divider>
      <div class="content">
        <div class="tabOffTop120">
          <!-- v-loading="loading" element-loading-text="数据正在努力加载中"  -->
          <el-table
            ref="multipleTable"
            :data="tableData.records"
            tooltip-effect="dark"
            style="width: 100%"
            v-loading="loading"
          >
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="name" label="功能集名称" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column  width="200" label="功能模块集合" show-overflow-tooltip> 
               <template slot-scope="scope">{{scope.row.functionCollectionString == 'null' || scope.row.functionCollectionString === '' ?'暂无':scope.row.functionCollectionString}}</template>
            </el-table-column>
            <el-table-column   width="200" label="公示模块集合" show-overflow-tooltip>
              <template slot-scope="scope">{{scope.row.publicCollectionString == 'null' || scope.row.publicCollectionString === '' ?'暂无':scope.row.publicCollectionString}}</template>
            </el-table-column>
            <el-table-column prop="enableIndex" label="是否纳入预警">  
              <template slot-scope="scope">{{scope.row.enableIndex === 0?'否':'是'}}</template>
            </el-table-column>
            <el-table-column   width="200" label="预警模块集合" show-overflow-tooltip>
               <template slot-scope="scope">{{scope.row.warningCollectionString == 'null' || scope.row.warningCollectionString === '' ?'暂无':scope.row.warningCollectionString}}</template>
            </el-table-column>
            <el-table-column prop="remarks" label="备注"></el-table-column>
            <el-table-column prop="createTime" width="150" label="创建时间"></el-table-column>
            <el-table-column prop="updateTime" width="150" label="更新时间"></el-table-column>
            <el-table-column label="操作" min-width="150">
              <template slot-scope="scope">
                <a href="javascript:;" class="operate-a" @click="go(scope.row.id,'edit')">编辑</a>
                <a href="javascript:;" class="operate-a" @click="go(scope.row.id,'detail')">详情</a>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-box">
          <el-pagination
            background
            @size-change="pageSizeChange"
            @current-change="pageCurrentChange"
            :current-page="queryLimit.current"
            :page-sizes="[10, 20, 30, 40,50]"
            :page-size="queryLimit.size"
            layout="total,prev, pager, next, sizes, jumper"
            :total="tableData.total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as api from "api/module";

export default {
  data() {
    return {
      loading: false,
      value: "",
      queryLimit: {
        keyword: '',
        current: 1,
        size: 10
      },
      tableData: []
    };
  },
  methods: {
    async getData() {
      this.loading = true;
      let result = await api.getModuleList(this.queryLimit);
      this.tableData = result.data;
      this.loading = false;
    },
    pageCurrentChange(num) {
      this.queryLimit.current = num;
      this.getData();
    },
    pageSizeChange(size) {
      this.queryLimit.size = size;
      this.getData();
    },
    searchTab() {
      this.queryLimit.current = 1
      this.getData()
    },
    add() {
      this.$router.push('/moduleAdd');
    },
    go(id,type) {
      let pageName = ''
      pageName = type === 'detail'? 'ModuleDetail':'ModuleEdit'
      this.$router.push({
        name: pageName,
        query: {
          id: id
        }
      })
    }
  },
  mounted() {
    this.getData()
  }
};
</script>
<style lang="scss" scoped>
.wrap {
  width: 100%;
  height: calc(100% - 40px);
  text-align: left;
  .innerBox {
    .filtrate {
      vertical-align: center;
      .year {
        font-size: 12px;
        line-height: 18px;
        color: #666666;
      }
    }
    .operate {
      .left {
        float: left;
      }
      .right {
        float: right;
      }
    }
  }
  .pagination-box {
    text-align: right;
    margin-top: 20px;
  }
}
</style>
